import React from 'react';
import MelilloChildDashboard from './Melillo/ChildDashboard';
import KindyRooChildDashboard from './KindyRoo/ChildDashboard';

const AnalyticsComponents = {
	MelilloChildDashboard,
	KindyRooChildDashboard
};

export default (name, props) => {
	// component does exist
	if (name && typeof AnalyticsComponents[name] !== 'undefined') {
		return React.createElement(AnalyticsComponents[name], props);
	}
	// component doesn't exist yet
	return React.createElement(
		() => <div>Component {name} has not been created yet.</div>
	);
};